<div class="section">
    <div class="plot-dropdown" #dropdownRoot>
        <label class="plot-dropdown-label">NE Plots</label>
        <button
            type="button"
            class="plot-dropdown-trigger"
            [class.open]="dropdownOpen"
            [disabled]="!plotOptions.length"
            (click)="toggleDropdown($event)"
            [attr.aria-expanded]="dropdownOpen"
            aria-haspopup="listbox"
        >
            <span class="plot-dropdown-trigger-label">{{ selectionLabel }}</span>
            <cds-icon shape="angle" [direction]="dropdownOpen ? 'up' : 'down'"></cds-icon>
        </button>
        <div *ngIf="dropdownOpen" class="plot-dropdown-panel" role="listbox">
            <ul class="plot-checkboxes">
                <li *ngFor="let plot of plotOptions">
                    <cds-checkbox>
                        <label>{{ plot.name }}</label>
                        <input
                            type="checkbox"
                            [checked]="isSelected(plot.name)"
                            (change)="togglePlot(plot)"
                        />
                    </cds-checkbox>
                </li>
            </ul>
        </div>
    </div>
    <button class="wiki-btn" (click)="goToWiki()">?</button>
</div>
<div class="data-container">
    <span *ngIf="!selectedResults.length">
        {{
            plotOptions.length
                ? 'Select one or more NE plots to view'
                : 'Run the Neighborhood enrichment job to view data'
        }}
    </span>
    <app-neighborhood-enrichment-result-content
        *ngFor="let nhood of selectedResults"
        [neighborhoodEnrichmentEntry]="nhood"
    ></app-neighborhood-enrichment-result-content>
</div>
